import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueHead from 'vue-head'
import Vue2TouchEvents from 'vue2-touch-events'

// pages

import home from './pages/home'
import skills from './pages/skills'
import portfolio from './pages/portfolio'
import form from './pages/form'

// styles

import './assets/style.sass'

Vue.use(VueHead)
Vue.use(VueRouter)
Vue.use(Vue2TouchEvents, {
    touchClass: '',
    tapTolerance: 90,
    swipeTolerance: 30,
    longTapTimeInterval: 400
})

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: home
		},
		{
			path: '/skills',
			component: skills
		},
		{
			path: '/portfolio',
			component: portfolio
		},
		{
			path: '/form',
			component: form
		}
	]
})

new Vue({
	el: '#app',
	router,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js